import styled from '@emotion/styled'
import {COLORS} from '../constants'

/** The failure card: a centred, bordered block that stands in for the whole tile grid. */
export const ErrorCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 20px 16px;
  border: 1px solid ${COLORS.border};
  border-radius: 8px;
  background-color: ${COLORS.cardBg};
  text-align: center;
`

/** The headline: "KPIs temporarily unavailable". */
export const ErrorTitle = styled.div`
  font-size: 13px;
  font-weight: 600;
  color: ${COLORS.foreground};
`

/** The supporting line under the headline. */
export const ErrorSub = styled.div`
  font-size: 12px;
  color: ${COLORS.mutedText};
`

/** The retry action — same primary-outline pill language as the tree's link pills. */
export const RetryButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 14px;
  border: 1px solid ${COLORS.brand};
  border-radius: 999px;
  background: ${COLORS.infoBg};
  color: ${COLORS.brand};
  font-family: inherit;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;

  &:hover {
    background: ${COLORS.brand};
    color: ${COLORS.cardBg};
  }
`
